import {LastModelBreach, SignalStatus} from '@domain/kiln-monitoring'

export const resolveStatus = ({
  thresholdStatus,
  modelBreach
}: {
  thresholdStatus?: SignalStatus
  modelBreach?: LastModelBreach
}) => {
  if (thresholdStatus === 'Alarm' || thresholdStatus === 'Warning') {
    return thresholdStatus
  }
  if (modelBreach) {
    return 'ModelBreach'
  }
  return thresholdStatus
}
